import React from "react";
import PropTypes from "prop-types";

import styles from "./RelatedFaqWrapper.module.css";
import classnames from "classnames";

const RelatedFaqWrapper = ({ topic, viewMoreLink, isLastRow = false }) => {
  return (
    <div
      className={classnames(styles.relatedFaqWrapper, {
        [styles.isLastRow]: isLastRow,
      })}
    >
      <ul>
        {topic.faqs &&
          topic.faqs.slice(0, 3).map((linkedFaq, i) => {
            const { link: { href, target } = {}, text } = linkedFaq;

            if (!href || !text) return;

            return (
              <li key={`${text}-${i}`}>
                <a
                  href={href}
                  target={target}
                  className={styles.relatedFaqItem}
                >
                  {text}
                </a>
              </li>
            );
          })}
      </ul>
      {topic.link && topic.link.link && (
        <a
          href={topic.link.link.href}
          className={styles.viewMoreLink}
          target={topic.link.link.target}
        >
          {viewMoreLink}
        </a>
      )}
    </div>
  );
};

export default RelatedFaqWrapper;

RelatedFaqWrapper.propTypes = {
  isLastRow: PropTypes.bool,
  topic: PropTypes.shape({
    faqs: PropTypes.array.isRequired,
    link: PropTypes.shape({
      link: PropTypes.shape({
        href: PropTypes.string,
        target: PropTypes.string,
      }),
      text: PropTypes.string,
    }),
  }),
  viewMoreLink: PropTypes.string,
};
